import { app_env, env_config } from "@/env-config";
import useDomain from "@/hooks/use-domain";
import { useSidebarLinks } from "@/hooks/useSidebarLinks";
import { Navigate } from "react-router-dom";

export default function Redirect() {
  const { data } = useSidebarLinks();

  const { isAdmin } = useDomain(env_config[app_env].domain);

  return (
    <Navigate
      to={
        isAdmin
          ? "/admin"
          : data?.navMain?.[0]?.items.filter(
              (item: any) => item?.isExternal !== true,
            )[0]?.url
      }
    />
  );
}
